import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wellfilter'
})

export class WellFilterPipe implements PipeTransform {

    transform(value: any, input: string,trigger:any) {
        if (input) { 
          input = input.toLowerCase().trim();

            return value.filter(function (obj: any) {
              if (input == "checked:true") {
                if (obj.isChecked == true) {
                  return obj;
                }
              } else {
                if ((obj.wellName.toLowerCase().indexOf(input) > -1) || (String(obj.wellID).toLowerCase().indexOf(input) > -1)
                  || (String(obj.batteryName).toLowerCase().indexOf(input) > -1) || (String(obj.fieldName).toLowerCase().indexOf(input) > -1)
                  || (String(obj.leaseNumber).toLowerCase().indexOf(input) > -1) || (String(obj.currentStatusName).toLowerCase().indexOf(input) > -1)) {
                  return obj
                }
              }
            })         
        }

        return value;
    }
}
